import React, { useContext, useEffect, useRef } from "react";
import { useState } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEye, fas } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import "../../Tabels/Tabels.css";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";

import { Modal, Row, Table } from "react-bootstrap";
import { CancelButton } from "../../common/Button";
import {
  formatDateToIST,
  formatTo12Hour,
  variant_type,
  convertTo12HourFormat,
  formatDateTime,
} from "../../../utils/common";
import { getData } from "../../../utils/api";
import ImagePreviewDialog from "../../common/ImagePreview/ImagePreview";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
library.add(fas);

const ExpertOrderDetailsModal = (props) => {
  const [data, setData] = useState({});
  const GetSingleData = async (id) => {
    const response = await getData(`/admin/orders/expert-order/${id}`);
    if (response?.success) {
      setData(response?.data);
    }
  };

  useEffect(() => {
    if (props.show) {
      GetSingleData(props.show);
    }
  }, [props.show]);

  const { IMG_URL } = useContext(Context);

  const dialogRef = useRef();
  const [selectedImage, setSelectedImage] = useState("");

  const openImage = (image) => {
    setSelectedImage(image);
    dialogRef.current?.showModal();
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Expert Order History
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {data?.Order_Assign_Experts?.length > 0 ? (
            data.Order_Assign_Experts.map((assign, index) => (
              <div key={assign.id} className="mb-4">
                <h5>Assignment #{index + 1}</h5>
                <div className="table-responsive">
                  <Table bordered>
                    <thead>
                      <tr>
                        <th>Sr No</th>
                        <th>Expert Name</th>
                        <th>Pickup User Name</th>
                        <th>Delivered User Name</th>
                        <th>Pickup Area</th>
                        <th>Drop Area</th>
                        <th>Expert Order Status</th>
                        <th>Delivery Type</th>
                        <th>Assign Date</th>
                        <th>Custom Note</th>
                        <th>Issue Reason</th>
                        <th>Issue Type</th>
                        <th>Signature</th>
                        <th>Images</th>
                      </tr>
                    </thead>

                    <tbody>
                      {assign?.Order_Experts?.map((expert) => {
                        const details = expert?.Expert_Order_Details || [];

                        return details.length > 0 ? (
                          details.map((detail, index) => (
                            <tr key={detail.id}>
                              {index === 0 && (
                                <>
                                  <td rowSpan={details.length}>
                                    {expert.serial_no}
                                  </td>
                                  <td rowSpan={details.length}>
                                    {expert?.Expert?.name || "-"}
                                  </td>
                                  <td rowSpan={details.length}>
                                    {expert?.Pickup_User?.name || "-"}
                                  </td>
                                  <td rowSpan={details.length}>
                                    {expert?.Deliverd_User?.name || "-"}
                                  </td>
                                  <td rowSpan={details.length}>
                                    {expert?.Pickup_Area?.name || "-"}
                                  </td>
                                  <td rowSpan={details.length}>
                                    {expert?.Drop_Area?.name || "-"}
                                  </td>
                                  <td rowSpan={details.length}>
                                    {expert?.Expert_Order_Status?.name || "-"}
                                  </td>
                                </>
                              )}

                              <td>{detail?.Delivered_Type?.name || "-"}</td>

                              <td>{formatDateTime(detail?.createdAt)}</td>

                              <td>{detail?.custom_note || "-"}</td>

                              <td>{detail?.issu_reason || "-"}</td>

                              <td>{detail?.Issue_Type?.name || "-"}</td>

                              <td>
                                {detail?.signature ? (
                                  <img
                                    src={detail.signature}
                                    alt="Signature"
                                    width="80"
                                    height="50"
                                  />
                                ) : (
                                  "-"
                                )}
                              </td>

                              <td>
                                <div className="d-flex flex-wrap gap-2">
                                  {detail?.Expert_Order_Images?.length > 0
                                    ? detail.Expert_Order_Images.map((img) => (
                                        <>
                                          <div className="image_holder">
                                            <img
                                              key={img.id}
                                              src={`${IMG_URL}${img.image}`}
                                              alt="Expert"
                                              width="100"
                                              height="100"
                                              style={{
                                                objectFit: "cover",
                                                border: "1px solid #ddd",
                                                borderRadius: "5px",
                                              }}
                                              onClick={() =>
                                                openImage(
                                                  `${IMG_URL}${img.image}`,
                                                )
                                              }
                                            />

                                            <FontAwesomeIcon
                                              icon={faEye}
                                              className="view_eye"
                                              onClick={() =>
                                                openImage(
                                                  `${IMG_URL}${img.image}`,
                                                )
                                              }
                                            />
                                          </div>
                                        </>
                                      ))
                                    : "-"}
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr key={expert.id}>
                            <td>{expert.serial_no}</td>
                            <td>{expert?.Expert?.name || "-"}</td>
                            <td>{expert?.Pickup_User?.name || "-"}</td>
                            <td>{expert?.Deliverd_User?.name || "-"}</td>
                            <td>{expert?.Pickup_Area?.name || "-"}</td>
                            <td>{expert?.Drop_Area?.name || "-"}</td>
                            <td>{expert?.Expert_Order_Status?.name || "-"}</td>
                            <td>-</td>
                            <td>{formatDateTime(expert?.createdAt)}</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                            <td>-</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-4">
              <h5>No expert assignments found.</h5>
            </div>
          )}
        </Modal.Body>

        <ImagePreviewDialog ref={dialogRef} image={selectedImage} />
      </Modal>
    </>
  );
};

export default ExpertOrderDetailsModal;
